module.exports = __webpack_public_path__ + "img/portrait.ed7272cb.jpg";